<div class="app-wrapper" *ngIf="access">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                    <!-- TODO: maybe add to title selectedRule.name -->
                  <core-title-section
                    [title]="titleText"
                    [description]="'This is where you can setup a rule.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                </div>
            </header>
            <div class="loader">
                <div class="dimmed" [hidden]="status == STATUS_DONE">
                    <div class="dimmed_title"></div>
                    <div class="dimmed_flex">
                        <div class="dimmed_box"></div>
                        <div class="dimmed_subtitle"></div>
                    </div>
                </div>
            </div>
           
            <div class="rules-add" *ngIf="status == STATUS_DONE">
                <settings-rules-rule-form
                    (cancel)="cancel($event)"
                    (submit)="save($event)"
                ></settings-rules-rule-form>
            </div>
        </div>
    </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
